module.exports = __webpack_public_path__ + "static/img/ku.5b16e491.png";